import { ChangeEvent, FC, useCallback, useEffect, useState } from "react";
import { Checkbox, Divider, Stack, Typography } from "@mui/material";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { currentOrganizationAccessEnabledSelector } from "@/store/organizations/organizationsSelectors";
import { usePatchUsersMeOrganisationsCurrentMutation } from "@/services/cloudchipr.api";
import { getCurrentOrganizationThunk } from "@/store/organizations/organizationsThunks";

export const OrganizationAccessSection: FC = () => {
  const [patchOrg, { isLoading }] =
    usePatchUsersMeOrganisationsCurrentMutation();

  const dispatch = useAppDispatch();
  const accessEnabled = useAppSelector(
    currentOrganizationAccessEnabledSelector,
  );
  const [checked, setChecked] = useState(accessEnabled);

  const checkboxChangeHandler = useCallback(
    async (event: ChangeEvent<HTMLInputElement>) => {
      setChecked(event.target.checked);
      await patchOrg({
        body: { access_enabled: event.target.checked },
      });
      dispatch(getCurrentOrganizationThunk());
    },
    [patchOrg, dispatch],
  );

  useEffect(() => {
    setChecked(accessEnabled);
  }, [accessEnabled]);

  return (
    <Stack>
      <Divider
        sx={{
          my: 4,
        }}
      />
      <Typography variant="h6" fontWeight="medium">
        Access
      </Typography>

      <Stack direction="row" spacing={0.5} alignItems="center">
        <Checkbox
          checked={checked}
          size="small"
          onChange={checkboxChangeHandler}
          disabled={isLoading}
        />
        <Typography variant="body1" color="text.secondary">
          Your account representative at Cloudchipr has read-only access to the
          Cloudchipr UI to deliver faster and more effective support for you and
          your team.
        </Typography>
      </Stack>
    </Stack>
  );
};
